<template>
  <div class="c-content">
    <!-- 地图 -->
    <div class="map">
      <!-- <baidu-map :center="center" :zoom="zoom" @ready="handler" style="width:100%;height:100%" @click="getClickInfo" :scroll-wheel-zoom='true' /> -->
      <baidu-map class="map map-content" :center="map_center" :zoom="map_zoom" @ready="mapReady" style="width:100%;height:100%"
        :double-click-zoom="true" ak="XRmUL1UdNqlStWef4o6WcZTFMeTO2fV0">
        <bm-marker :position="map_center" :dragging="true" @click="show=true">
          <bm-info-window :show="show" @close="show=false" @open="show=true">
            <div>{{$store.state.langStates == 'zh'?address.company:address.company_en}}</div>
            <div>地址：{{$store.state.langStates == 'zh'?address.address:address.address_en}}</div>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
    </div>
    <!-- 联系我们 -->
    <div class="we">
      <div class="main-center">
        <div class="info">
          <p class="main-font30">{{$t('title.contactUs')}}</p>
          <div class="main-font24">
            <p class="font-bold">{{$store.state.langStates == 'zh'?address.company:address.company_en}}</p>
            <p>
              <a-icon type="phone" theme="filled" style="margin-right: 10px;transform:rotate(90deg);" />{{address.tel}}
            </p>
            <p>
              <a-icon type="mail" theme="filled" style="margin-right: 10px;" />{{address.email}}
            </p>
            <p>
              <icon-font type="icondingwei" style="margin-right: 10px;" />
              {{$store.state.langStates == 'zh'?address.address:address.address_en}}
            </p>
          </div>
        </div>
        <div class="main-font30">{{$t('title.qg')}}</div>
        <div class="main-center" v-for="(item,i) in distributors" :key="i">
          <div class="box" v-if="$store.state.langStates == 'zh'">
            <img :src="'http://' + item.image_file">
            <div class="main-font24">
              <p>{{item.name}}</p>
              <p>
                <a-icon type="phone" theme="filled" style="margin-right: 10px;transform:rotate(90deg);" />{{item.phone}}
              </p>
              <p>
                <icon-font type="icondingwei" style="margin-right: 10px;" />{{item.address}}
              </p>
            </div>
          </div>
          <div class="box" v-else>
            <img :src="'http://' + item.image_file_en">
            <div class="main-font24">
              <p>{{item.name_en}}</p>
              <p>
                <a-icon type="phone" theme="filled" style="margin-right: 10px;transform:rotate(90deg);" />{{item.phone}}
              </p>
              <p>
                <icon-font type="icondingwei" style="margin-right: 10px;" />{{item.address_en}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Icon} from 'ant-design-vue';
  const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1684651_y3p2wp94ntj.js',
  });
  import {BaiduMap,BmScale,BmGeolocation,BmMarker,BmLabel,BmInfoWindow} from 'vue-baidu-map'
  export default {
    components: {IconFont,BaiduMap,BmMarker,BmInfoWindow},
    name: 'TestBaiDu',
    data() {
      return {
        map_zoom: 15, // 初始化地图缩放大小这两个必须有
        map_center: {
          lng: 0,
          lat: 0
        }, // 初始化中心点位置
        show:true,
        distributors: '',
        address: '',
      }
    },
    created() {
      this.init(this.$store.state.langStates)
      this.getAddress()
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/download') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods: {
      init(lang) {
        this.$api.dongjuapi.distributors(lang).then(res => {
          this.distributors = res.data.data
        }).catch(err => {

        })
      },
      getAddress() {
        this.$api.dongjuapi.getAddress().then(res => {
          if (res.data.code == 200) {
            this.address = res.data.data
            this.getLocationPoint()
          }
        })
      },
      // 地图初始化
      mapReady({BMap,map}) {
        console.log(BMap, map);
      },
      // 动态添加标注
      getLocationPoint() {
        this.$jsonp('http://api.map.baidu.com/geocoding/v3/', {
          address: this.address.address,
          output: "json",
          ak: 'XRmUL1UdNqlStWef4o6WcZTFMeTO2fV0',
        }).then((res) => {
          console.log(res)
          let lng = res.result.location.lng
          let lat = res.result.location.lat
          console.log(lng, lat)
          this.map_center.lng = lng
          this.map_center.lat = lat
          this.map_zoom = 15
        }).catch(err => {
          console.log(err)
        })
      },
      getClickInfo(e) {
        console.log(e.point.lng)
        console.log(e.point.lat)
        this.center.lng = e.point.lng
        this.center.lat = e.point.lat
      }
    }
  }
</script>

<style lang="less">
  .c-content {
    margin-top: 160px;

    .map {
      width: 100%;
      height: 480px;
    }

    .we {
      background: #fff;
      padding: 80px 0;

      .info {
        padding-bottom: 80px;

        .main-font24 {
          color: #999999;
        }
      }

      .box {
        height: 282px;
        line-height: 20px;
        border: 1px solid rgba(187, 187, 187, 1);
        margin: 30px 0;
        display: flex;
        align-items: center;
        justify-content: start;
        color: #999;

        img {
          width: 500px;
          height: 280px;
          margin-right: 50px;
        }

        div {

          p {
            width: 100%;
            line-height: 36px;
          }
        }
      }
    }
  }
</style>
